import axios from 'axios'

export default {

    get: function () {
        return axios.get('/api/settings');
    }

}



// WEBPACK FOOTER //
// ./resources/assets/js/api/settings.js